import React, { useEffect, useState, useRef } from "react";
import { HiChevronDown } from "react-icons/hi";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Ripple, initTWE } from "tw-elements";
import { useLanguage } from "../../context";
import { setLocalStorage } from "../../helpers/localStorage";
import { getUrlOpposite, getUrlOppositeBlog } from "../../helpers/utils";
import { getLocalizedPath, stripLanguagePrefix } from "../../helpers/routes";
import { motion } from "framer-motion";
import { createPortal } from "react-dom";

const Language = ({ invert = false }) => {
  const intl = useIntl();
  const { language, changeLanguage: setLanguage } = useLanguage();
  const { pathname, state } = useLocation();
  const [isChanging, setIsChanging] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  // const params = useParams();
  let history = useNavigate();
  let urlOpposite = "";

  useEffect(() => {
    initTWE({ Dropdown, Ripple });
  }, []);

  // Update dropdown position when button is clicked
  const updateDropdownPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 160;
      const left = Math.min(rect.left, Math.max(8, window.innerWidth - dropdownWidth - 8));
      setDropdownPosition({
        top: rect.bottom + 8,
        left
      });
    }
  };

  // Handle dropdown toggle
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    if (!isDropdownOpen) {
      updateDropdownPosition();
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isDropdownOpen]);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handlePositionChange = () => {
      updateDropdownPosition();
    };

    window.addEventListener("scroll", handlePositionChange, true);
    window.addEventListener("resize", handlePositionChange);
    return () => {
      window.removeEventListener("scroll", handlePositionChange, true);
      window.removeEventListener("resize", handlePositionChange);
    };
  }, [isDropdownOpen]);

  const langs = [
    {
      key: "en",
      value: intl.formatMessage({ id: "en" }),
    },
    {
      key: "fr",
      value: intl.formatMessage({ id: "fr" }),
    },
  ];

  const changeLanguage = async (value) => {
    if (language !== value && !isChanging) {
      setIsChanging(true);
      console.log("value ---- changeLanguage ", value);
      
      // Simuler un léger délai pour montrer le chargement
      await new Promise(resolve => setTimeout(resolve, 300));
      
      setLocalStorage("@language", value);
      await setLanguage(value);
      
      const isSpecialRoute =
        `${pathname}`.startsWith("/blog") ||
        `${pathname}`.startsWith("/fr/blog") ||
        `${pathname}`.startsWith("/blog/categories") ||
        `${pathname}`.startsWith("/fr/blog/categories") ||
        `${pathname}`.startsWith("/info") ||
        `${pathname}`.startsWith("/fr/info") ||
        `${pathname}`.startsWith("/fr/sub") ||
        `${pathname}`.startsWith("/sub") ||
        `${pathname}`.startsWith("/fr/slider") ||
        `${pathname}`.startsWith("/slider") ||
        `${pathname}`.startsWith("/fr/service") ||
        `${pathname}`.startsWith("/service");

      if (isSpecialRoute) {
        urlOpposite = getUrlOppositeBlog(pathname);
      } else {
        urlOpposite = getUrlOpposite(pathname);
      }

      if (!urlOpposite || urlOpposite === pathname) {
        const normalizedPath = stripLanguagePrefix(pathname);
        urlOpposite = getLocalizedPath(normalizedPath, value);
      } else {
        urlOpposite = getLocalizedPath(stripLanguagePrefix(urlOpposite), value);
      }
      
      window.location.href = urlOpposite;

      setIsChanging(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {/* border-l-[1px] border-l-white */}
      {/* <select
        className="text-[0.8rem] appearance-none border-none text-white bg-black-150 cursor-pointer focus:outline-0  focus:ring-0"
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
      >
        <option value="en" className="text-black bg-white cursor-pointer">
          {intl.formatMessage({ id: "en" })}
        </option>
        <option value="fr" className="text-black bg-white cursor-pointer">
          {intl.formatMessage({ id: "fr" })}
        </option>
        <option value="fr" className="text-black bg-white cursor-pointer">
          {intl.formatMessage({ id: "es" })}
        </option>
      </select> */}

      {/* <Dr2
        as={"div"}
        label=""
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="!py-0 rounded-none bg-black-150 !-top-[4px] border-t-0"
        renderTrigger={() => (
          <div className="flex items-center gap-1 cursor-pointer">
            <span className="py-1 text-white text-[0.8rem]">
              {intl.formatMessage({ id: language })}
            </span>
            <HiChevronDown className="text-white" />
          </div>
        )}
        dismissOnClick={false}
      >
        {langs.map((lang, i) => (
          <DropdownItem
            key={lang.key}
            as={"div"}
            onClick={() => changeLanguage(lang.key)}
            className={`text-white text-[0.8rem] focus:outline-0 focus:outline-offset-0 !py-1 hover:!bg-gray-100 hover:!text-black ${language === lang.key ? "!bg-gray-100 text-black" : ""
              }`}
          >
            {intl.formatMessage({ id: lang.key })}
          </DropdownItem>
        ))}
      </Dr2> */}

      <div className="relative px-3">
        <motion.button
          ref={buttonRef}
          className={`flex items-center gap-1 text-[0.8rem] transition duration-150 ease-in-out focus:outline-0 focus:ring-0 motion-reduce:transition-none ${
            invert ? 'text-slate-200 hover:text-white' : 'text-slate-600 hover:text-[#16A34A]'
          }`}
          type="button"
          onClick={toggleDropdown}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={isChanging}
        >
          {isChanging ? (
            <motion.div
              className={`w-3 h-3 border border-t-transparent rounded-full mr-1 ${invert ? 'border-slate-200' : 'border-slate-600'}`}
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            />
          ) : (
            <>
              {intl.formatMessage({ id: language })}
              <motion.div
                animate={{ rotate: isDropdownOpen ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
<HiChevronDown className={invert ? 'text-slate-200' : 'text-slate-600'} />
              </motion.div>
            </>
          )}
        </motion.button>
      </div>

      {/* Dropdown rendu dans le body via portal */}
      {isDropdownOpen && createPortal(
        <ul
          className="fixed z-[9999999] min-w-[160px] list-none overflow-hidden border border-slate-200 bg-white bg-clip-padding text-[0.8em] shadow-lg"
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`
          }}
        >
          {langs.map((lang) => (
            <motion.li
              key={lang.key}
className={`px-2 py-1 text-[0.8rem] focus:outline-0 focus:outline-offset-0 transition-colors duration-200 ${language === lang.key
                  ? "bg-[#16A34A] text-white"
                  : "text-slate-700"
                }`}
              whileHover={{ x: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              <button
                type="button"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => {
                  changeLanguage(lang.key);
                  setIsDropdownOpen(false);
                }}
                className="w-full flex items-center justify-between px-2 py-1 text-left cursor-pointer hover:bg-[#16A34A]/10 hover:text-[#15803D] rounded-sm"
                disabled={isChanging}
              >
                <span>{lang.value}</span>
                {language === lang.key && (
                  <motion.svg
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="w-4 h-4 ml-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </motion.svg>
                )}
              </button>
            </motion.li>
          ))}
        </ul>,
        document.body
      )}
    </div>
  );
};

export default Language;
